import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f4bc20a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-node" }
const _hoisted_2 = { class: "navigation-node-inner-text" }
const _hoisted_3 = {
  key: 0,
  class: "navigation-node-inner-icon"
}
const _hoisted_4 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "navigation-node-group" }

import { computed, Ref, ref } from 'vue';
import { NavigationNodeRender, NAVIGATION_TYPES } from './types';
import NavigationButton from './NavigationButton.vue';
import { useRouter } from 'vue-router';
import NavigationNode from './NavigationNode.vue';
import TransitionExpanded from '@ui-kit/transition/TransitionExpanded.vue';

interface Props {
  pathPrefix?: string,
  data: NavigationNodeRender,
}
type ChildrenRefType = Array<InstanceType<typeof NavigationNode>>;

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationNode',
  props: {
    pathPrefix: { default: '' },
    data: null
  },
  setup(__props: any, { expose }) {

const props = __props as { pathPrefix: string, data: NavigationNodeRender }



const hasChildren = computed(() => props.data.nodes.length > 0);
const isOpen = ref<boolean>(false);
const router = useRouter();
const childrenRef: Ref<ChildrenRefType> = ref([]);

const clickHandler = () => {
  if (hasChildren.value){
    isOpen.value = !isOpen.value;
  } else {
    router.push(props.data.fullPath);
  }
}

const openIfActive = () => {
  if (props.data.isActive){
    isOpen.value = true;
  }
  childrenRef.value.forEach((child) => child.openIfActive());
}

expose({
  openIfActive,
})

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["navigation-node-inner", {active: __props.data.isActive}]),
      onClick: clickHandler
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.data.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_FontAwesomeIcon, {
                icon: __props.data.icon
              }, null, 8, ["icon"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(__props.data.label), 1)
      ]),
      (_unref(hasChildren))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (isOpen.value)
              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 0,
                  icon: "caret-up"
                }))
              : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 1,
                  icon: "caret-down"
                }))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(TransitionExpanded, null, {
      default: _withCtx(() => [
        (_unref(hasChildren) && isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.nodes, (node) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (node.type === _unref(NAVIGATION_TYPES).node)
                      ? (_openBlock(), _createBlock(NavigationNode, {
                          key: 0,
                          ref_for: true,
                          ref_key: "childrenRef",
                          ref: childrenRef,
                          data: node,
                          "path-prefix": __props.pathPrefix + (__props.data.path || '')
                        }, null, 8, ["data", "path-prefix"]))
                      : _createCommentVNode("", true),
                    (node.type === _unref(NAVIGATION_TYPES).button)
                      ? (_openBlock(), _createBlock(NavigationButton, {
                          key: 1,
                          data: node
                        }, null, 8, ["data"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})